import MyNotifications from "../MyNotifications/MyNotifications";

export function NotificationsScreen() {
  return <MyNotifications ObjectIds={""} ObjectType={1}></MyNotifications>;
}
